import { Box, Typography } from '@material-ui/core';
import React from 'react';

import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { ConfirmedIcon, DeclinedIcon } from './components';

type SummaryType = 'CONFIRMED' | 'DECLINED';

interface SummaryProps {
    type: SummaryType;
}

export const Summary = (props: SummaryProps): React.ReactElement => {
    const { translate } = injectTSDI(I18n);

    return (
        <Box
            display="flex"
            flexGrow={1}
            alignItems="center"
            flexDirection="column"
            justifyContent="space-around"
        >
            <Box alignItems="center" display="flex" flexDirection="column">
                {props.type === 'DECLINED' ? (
                    <DeclinedIcon />
                ) : (
                    <ConfirmedIcon />
                )}
                <Typography align="center">
                    {translate(
                        props.type === 'DECLINED'
                            ? 'comm.center.marketing.consent.summary.declined'
                            : 'comm.center.marketing.consent.summary.confirmed'
                    )}
                </Typography>
            </Box>
        </Box>
    );
};
